import { render, staticRenderFns } from "./companyAccount.vue?vue&type=template&id=f98bf1bc&scoped=true&"
import script from "./companyAccount.vue?vue&type=script&lang=js&"
export * from "./companyAccount.vue?vue&type=script&lang=js&"
import style0 from "./companyAccount.vue?vue&type=style&index=0&id=f98bf1bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98bf1bc",
  null
  
)

export default component.exports